import React from "react";
import { BattingLineup } from "./batting-lineup";
import { PitchingLineup } from "./pitching-lineup";

export const GameLineups = ({ battingLineups = [], pitchingLineups = [], homeTeam, awayTeam }) => {
  // Separate lineups by team
  const awayBatting = battingLineups.filter((p) => p.team_name === awayTeam);
  const homeBatting = battingLineups.filter((p) => p.team_name === homeTeam);
  const awayPitching = pitchingLineups.filter((p) => p.team_name === awayTeam);
  const homePitching = pitchingLineups.filter((p) => p.team_name === homeTeam);

  return (
    <div className="space-y-6">
      <div>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <BattingLineup lineup={awayBatting} teamName={awayTeam} />
          </div>
          <div>
            <BattingLineup lineup={homeBatting} teamName={homeTeam} />
          </div>
        </div>
      </div>

      <div>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <PitchingLineup lineup={awayPitching} teamName={awayTeam} />
          </div>
          <div>
            <PitchingLineup lineup={homePitching} teamName={homeTeam} />
          </div>
        </div>
      </div>
    </div>
  );
};
